<template>
  <div class="accessPlatform">
    <div class="banner">
        <img class="banner_bg" src="@/assets/images/accessPlatform/banner.png" alt="">
        <img class="banner_text" src="@/assets/images/accessPlatform/text.png" alt="">
    </div>
    <div class="product" style="width:100%">
        <div class="ym">
            <img class="banner_bg" style="height: 830px;" src="@/assets/images/accessPlatform/product_ym.png" alt="">
            <div class="ym_box">
                <div class="title" style="margin-top:62px">云幕</div>
                <div class="introduce">一键发布，帮助您高效管理屏幕</div>
                <div class="info">
                    <div><img src="@/assets/images/accessPlatform/add.png" alt="">所见即所得的节目制作</div>
                    <div><img src="@/assets/images/accessPlatform/shop.png" alt="">万店规模屏幕管理的最佳实践</div>
                    <div><img src="@/assets/images/accessPlatform/tv.png" alt="">支持一体机以及主流电视的安装及开机自启动</div>
                </div>
                <a class="btn" href="/products/oneMachine">查看详情</a>
            </div>
            <img class="ym_img" src="@/assets/images/accessPlatform/ym_info.png" alt="">
        </div>
        <div class="yqm">
            <img class="banner_bg" style="height: 950px;" src="@/assets/images/accessPlatform/product_yqm.png" alt="">
            <div class="yqm_box">
                <div class="title" style="margin-top:116px">云千目</div>
                    <div class="introduce">高效巡店，帮助您有效推进门店标准化</div>
                    <div class="info">
                    <div><img src="@/assets/images/accessPlatform/address.png" alt="">线上、现场、考评、巡检等多种巡店模式</div>
                    <div><img src="@/assets/images/accessPlatform/user.png" alt="">总部、区域、门店等多层级分组管理</div>
                    <div><img src="@/assets/images/accessPlatform/picture.png" alt="">发现、改正、审核、数据统计的闭环操作</div>
                    <div><img src="@/assets/images/accessPlatform/AI.png" alt="">AI赋能提升效率，支持多后台管理</div>
                </div>
            <a class="btn" href="/products/atenCamera">查看详情</a>
            </div>
            <img class="ym_img" src="@/assets/images/accessPlatform/yqm_info.png" alt="">
        </div>
        <div class="partner">
            <div class="title">合作伙伴</div>
            <div class="introduce">深耕泛零售行业，已服务数万家门店</div>
            <div class="partner-institution-logo-wrap" ref="logo_warp">
                <div class="mask left-mask"></div>
                <div class="mask right-mask"></div>
                <div  class="scroll_box">
                   <div class="container">
                        <div v-for="(path, index) in imageList[0]" :key="'0'+index" class="logo-box"><img :src="path" alt=""></div>
                   </div>
                </div>
                <div class="scroll_box" style="padding-left:30px;">
                    <div class="container" style="animation-duration: 45s;">
                        <div v-for="(path, index) in imageList[1]" :key="'1'+index" class="logo-box"><img :src="path" alt=""></div>
                   </div>
                </div>
                <div class="scroll_box">
                    <div class="container">
                        <div v-for="(path, index) in imageList[2]" :key="'2'+index" class="logo-box"><img :src="path" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import images from '@/utils/getImages.js'
export default {
    name:"HomeMain",
    computed: {
        imageList() {
            return images.map(m => [...m, ...m])
        },
    }
}
</script>

<style scoped>
.accessPlatform {
    text-align: center;
}
.banner_bg {
    width: 100%;
}
.banner {
    position: relative;
}
.banner .banner_text {
    width: 50%;
    position: absolute;
    top:32%;
    left:50%;
    transform: translateX(-50%);
}

.title {
    color: #303133;
    font-size: 50px;
    font-weight: 600;
}
.ym {
    position: relative;
    width: 100%;
}

.ym .ym_box {
    position: absolute;
    top:0;
    left:50%;
    transform: translateX(-50%);
}
.ym_img {
    position: absolute;
    bottom:4px;
    left:50%;
    transform: translateX(-50%);
}
.introduce {
    margin-top: 30px;
    color:#75798C;
    font-size: 22px;
    line-height: 30px;
}
.btn {
    display: inline-block;
    width: 156px;
    height: 53px;
    background: #fd8415;
    border-radius: 2px;
    text-align: center;
    line-height: 53px;  
    font-size: 18px;
    font-weight: 600;
    color:#fff;
    text-decoration: none;
}

.ym .btn {
    margin: 6% auto;
}

.ym .info {
    color: #3B436B;
    font-size: 18px;
    width: 994px;
    display: flex;
    justify-content: space-between;
    margin-top: 8%;
}

.yqm {
    position: relative;
}

.yqm .yqm_box {
    position: absolute;
    top:0;
    left:50%;
    transform: translateX(-50%);
}

.yqm .info {
    width: 830px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 76px;
    color: #3B436B;
    font-size: 18px;
}

.yqm .info div {
    margin-bottom: 30px;
    text-align: left;
}

.yqm .info div:nth-child(1),.yqm .info div:nth-child(3) {
     margin-right: 120px;
}

.info div img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 12px;
}

.yqm .btn {
    margin: 5% auto;
}

.partner {
    margin-top: 126px;
}

.partner-institution-logo-wrap {
    position: relative;
    width: 100vw;
    margin: 88px auto 126px;
}

.mask {
    position: absolute;
    width: 200px;
    height: 351px;
    z-index: 1;
}

.left-mask {
    left:0;
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.92) 58%, #FFFFFF 100%);
}

.right-mask {
    right:0;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.92) 58%, #FFFFFF 100%);
}

.scroll_box {
    width: 100vw;
    height: 98px;
    margin: auto;
    margin-bottom: 20px;
    overflow: hidden;
    position: relative;
}

.scroll_box .container {
    position: absolute;
    display: flex;
    /* width: 3584px; */
    animation: scroll 60s linear infinite normal;
}

.scroll_box .container .logo-box {
    width: 204px;
    height: 98px;
    margin-right: 20px;
}

.scroll_box .container .logo-box img {
    display: inline-block;
}

@keyframes scroll {
    0% {
        transform: translateZ(0);
    }
    100% {
        transform: translate3d(-50%,0,0);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AccessPlatform.vue